import { ref, watch } from 'vue';

// Bumped when the current user's models change outside the dashboard (e.g. a
// share invitation accepted from the notification bell)
const version = ref(0);

/** Tell an open dashboard to reload the user's models and folders. */
export const notifyDashboardChanged = () => {
  version.value++;
};

/** Run `refresh` whenever notifyDashboardChanged is called. */
export const onDashboardChanged = (refresh: () => void) =>
  watch(version, () => refresh());
